export default __webpack_public_path__ + "3532f210041657b2e7a49e16b5aa9d7c.svg";